import { useEffect } from "react";
import { useCompanyStore } from "@/store";
import { resolveAccentHex, deriveAccentColors, accentInkVars } from "@njbsoft/store";

export function useAccentSync() {
  const accentColor = useCompanyStore((s) => s.accentColor);
  const resolvedTheme = useCompanyStore((s) => s.resolvedTheme);

  useEffect(() => {
    const hex = resolveAccentHex(accentColor);
    const colors = deriveAccentColors(hex, resolvedTheme);
    const ink = accentInkVars(hex);
    const el = document.documentElement;
    el.style.setProperty("--color-primary", colors.primary);
    el.style.setProperty("--color-primary-hover", colors.primaryHover);
    el.style.setProperty("--color-secondary", colors.secondary);
    el.style.setProperty("--color-primary-light", colors.primaryLight);
    // CSS cannot call a function, so both on-accent inks are derived here and
    // published as custom properties, each referenced with a literal fallback
    // that paints before this effect first runs. The LIGHT property serves the
    // app shell's `--color-on-primary` in both modes — the shell paints the
    // raw accent in light and dark alike. The DARK property serves the shared
    // form document's dark blocks: the form stylesheet lightens the accent
    // before painting it, so the ink sitting on THAT fill must be derived from
    // the lightened accent, not the raw one.
    el.style.setProperty("--color-accent-ink-light", ink.light);
    el.style.setProperty("--color-accent-ink-dark", ink.dark);
  }, [accentColor, resolvedTheme]);
}
